import React, { Component } from "react";
import Props from "./Props";

class JustifyContent extends Component {
  state = {
    property: "justify-content",
    definition:
      "The justify-content property is a sub-property of the Flexible Box Layout module. It defines the alignment along the main axis. It helps distribute extra free space leftover when either all the flex items on a line are inflexible, or are flexible but have reached their maximum size.",
    defaultOption: "flex-start",
    options: [
      "flex-start",
      "flex-end",
      "center",
      "space-between",
      "space-around",
      "space-evenly",
    ],
    flexContainer: { fcHeight: "120px", fcWidth: "600px" },
    flexItems: [
      { label: 1, itemWidth: "160px" },
      { label: 2 },
      { label: 3, itemWidth: "160px" },
    ],
  };

  render() {
    const { state } = this;

    return <Props {...state} />;
  }
}

export default JustifyContent;
